<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <!-- <router-link v-bind:to="'/anexos_membresia/' + id_usuario" class="btn btn-orange rounded-pill">
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link> -->
              <button_back></button_back>
              <br />
            </div>
            <div class="mt-2 mb-3">
              <h3 class="text-orange fw-bold">
                {{ usuario.nombres }} {{ usuario.apellidos }}
              </h3>
            </div>
            <div class="card">
              <div class="card-header">
                <h4 class="text-orange fw-bold">Confirmación cliente</h4>
              </div>
              <div class="card-body">
                <div>
                  <div class="card card-body border">
                    <div class="text-center mt-3">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="main_mail" v-model="main_mail"
                          @change="check($event)">
                        <label class="form-check-label" for="main_mail">
                          Enviar correo de confirmación al cliente
                        </label>
                      </div>
                    </div>
                    <div class="text-center mt-3" v-if="beneficiarios.length > 0">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="ben_mail" v-model="ben_mail"
                          @change="check($event)">
                        <label class="form-check-label" for="ben_mail">
                          Enviar correo de confirmación a los beneficiaros
                        </label>
                      </div>
                    </div>
                    <div class="text-center mt-3">
                      <button v-on:click="send_all_mails()" class="btn btn-orange btn-lg rounded-pill">
                        <i class="bx bx-envelope"></i> Enviar correos
                      </button>

                    </div>
                  </div>
                </div>
                <div class="text-end">
                  <router-link to="/" class="btn btn-orange btn-lg rounded-pill ms-1">
                    <i class="bx bx-chevron-left"></i>
                    Finalizar
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { defineAsyncComponent } from 'vue';
export default {
  name: "Contrato",
  metaInfo: {
    title: "Contrato - Reddy Backoffice",
  },
  components: {
    button_back: defineAsyncComponent(() => import('../../components/BackBtn')),
  },
  data() {
    return {
      loading: true,
      main_mail: false,
      ben_mail: false,
      id_usuario: null,
      beneficiarios: [],
      usuario: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_usuario = this.$route.params.id_usuario;
    this.get_usuario();
  },
  methods: {
    get_usuario: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "clientes/cliente/" + this.id_usuario, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
            return false;
          }
          this.usuario = response.data.data;
          this.get_beneficiarios();
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    aprobar_firma_manual: function () {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_usuario: this.id_usuario,
      };
      axios
        .post(this.$base_url + "clientes/aprobar_firma", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Contrato firmado",
              text: response.data.message,
            });
            vm.get_usuario();
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },

    send_mail_contrato: function () {
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
      };
      let params = {
        id_usuario: this.id_usuario,
      };
      axios
        .post(this.$base_url + "membresias/firmar_contrato", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
            vm.loading = false;
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "<i class='fa fa-check-circle'></i> ¡Excelente!",
              text: "Has realizado correctamente al firma de tu contrato.",
            });
            vm.loading = false;
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    send_mail_beneficiarios: function ($id_usuario) {
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
      };
      let params = {
        id_usuario: $id_usuario,
      };
      axios
        .post(this.$base_url + "membresias/mail_for_beneficiario", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
            vm.loading = false;
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "<i class='fa fa-check-circle'></i> ¡Excelente!",
              text: "Has realizado correctamente al firma de tu contrato.",
            });
            vm.loading = false;
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    get_beneficiarios: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(
          this.$base_url +
          "membresias/beneficiarios/" +
          this.usuario.membresia.id_membresia,
          config,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.beneficiarios = response.data.data.beneficiarios;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    send_mails() {
      this.beneficiarios.forEach(beneficiario => {
        this.send_mail_beneficiarios(beneficiario.id_usuario);
      });
    },
    generar_contrato: function () {
      window.open(
        this.$base_url + "download/contrato_membresia/" + this.id_usuario,
        "_blank"
      );
    },
    copiar_enlace_contrato: function () {
      var content = this.$refs.input_enlace_contrato;
      content.select();
      document.execCommand("copy");
    },
    check: function (e) {
      console.log(e)
    },
    send_all_mails() {
      if (this.main_mail == true) {
        this.send_mail_contrato();
      }
      if (this.ben_mail == true) {
        this.send_mails();
      }
    }
  },
};
</script>

<style scoped>
.form-check {
  margin: auto;
  display: table;
}
</style>